import { render, staticRenderFns } from "./cRptDown.vue?vue&type=template&id=528ca3da&scoped=true&"
import script from "./cRptDown.vue?vue&type=script&lang=js&"
export * from "./cRptDown.vue?vue&type=script&lang=js&"
import style0 from "./cRptDown.vue?vue&type=style&index=0&id=528ca3da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528ca3da",
  null
  
)

export default component.exports